import * as CoreActions from '@common/_store/core.actions';

import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {UsersHTTPService} from '../../cabinet/users/_services/users.HTTP.service';

@Injectable()

export class CoreEffects {

    httpError$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(CoreActions.HttpErrorDetected),
            tap((action) => {
                const hasTranslation =
                    (this.translateService.instant(`errors.${action.key}.text`) != `errors.${action.key}.text` || this.translateService.instant(`errors.${action.key}.title`) != `errors.${action.key}.title`);
                if (hasTranslation) {
                    let text = this.translateService.instant('errors.' + action.key + '.text', {data: action.data?.name});
                    if ((action.key == 'sms_gateway_error' || action.key == 'smtp_server_error') && action.data) {
                        text = action.data;
                    }
                    this.toastrService.error(text, this.translateService.instant('errors.' + action.key + '.title'), {
                        enableHtml: true,
                        timeOut: 5000
                    });
                } else {
                    this.toastrService.error(this.translateService.instant('errors.internal_error.text'), this.translateService.instant('errors.internal_error.title'));
                }
            })
        );
    }, {dispatch: false});

    constructor(
        private actions$: Actions,
        private translateService: TranslateService,
        private toastrService: ToastrService,
        private usersApiService: UsersHTTPService
    ) {
    }
}
